import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const RHCA_ReleaseOfInformation = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='RHCA_ReleaseOfInformation' className='file-pdf-document'>
            <div className='file-template'> 


                <p className='w-750'> <center> <h3> Client Rights Notice and Client Rights Handbook </h3> </center> </p>

                <p className='w-750'>
                    I &nbsp;
                    <input type='text' id='txtAuthorize' name='txtAuthorize' placeholder='authorize (Client or Legally Responsible Person)' className='add-only w-200 custom-add-only' /> &nbsp; hereby &nbsp; <input type='text' id='txtHealthInformation' name='txtHealthInformation' placeholder='(Name of Provider/Organization)' className='add-only w-200 custom-add-only' /> &nbsp; to obtain/disclose specific health information from the records of the above-named to/from:
                </p>

                <p className='w-750'> <center> <h5> <b> Rising Hope Clinical Assistance, LLC, <br /> 300 Perimeter Center, N. Ste.300, <br /> Dunwoody, GA 30346 <br />
                    Office: 678-273-3005 Fax: 877-564-4386 <br /> Email: admin@rhcaga.com
                </b> </h5> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> For the specific purpose(s): </span> </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbTreatment' name='cbTreatment' className='add-only' value='Anger' /> Treatment &nbsp;
                    <input type='checkbox' id='cbCareCoordination' name='cbCareCoordination' className='add-only' value='Happy' /> Care Coordination &nbsp;
                    <input type='checkbox' id='cbExternalAudits' name='cbExternalAudits' className='add-only' value='Confused' /> Internal and External Audits &nbsp;
                    <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Confused' /> Other: <br />
                    <input type='text' id='txtSpecificOther' name='txtSpecificOther' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Specific Information to be Disclosed/Obtained: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtSpecificInformation' name='txtSpecificInformation' className='add-only' />
                </p>

                <p className='w-750'> I understand that this authorization will expire on the following date, event or condition: one year from the date of signature, upon
                </p>

                <p className='w-750'> I understand that if I fail to specify an expiration date or condition, this authorization is valid for the period of time needed to fulfill its purpose for up to one year, except for disclosures for financial transactions, wherein the authorization is valid indefinitely. I also understand that I may revoke this authorization at any time and that I will be asked to provide a written/electronic letter of revocation. I further understand that any action taken on this authorization prior to the rescinded date is legal and binding.

                </p>
                <p className='w-750'> I understand that my information may not be protected from re-disclosure by the requester of the information; however, if this information is protected by the Federal Substance Abuse Confidentiality Regulations, the recipient may not re-disclose such information without my further written authorization unless otherwise provided for by state or federal law.
                </p>

                <p className='w-750'> I understand that if my record contains information relating to HIV infection, AIDS or AIDS-related conditions, alcohol abuse, drug abuse, psychological or psychiatric conditions, or genetic testing this disclosure will include that information.
                </p>

                <p className='w-750'> I also understand that I may refuse to sign this authorization and that my refusal to sign will not affect my ability to obtain treatment, payment for services, or my eligibility for benefits; however, if a service is requested by a non-treatment provider (e.g., insurance company) for the sole purpose of creating health information (e.g., physical exam), service may be denied if authorization is not given. If treatment is research-related, treatment may be denied if authorization is not given. I further understand that I may request a copy of this signed authorization
                </p>

                <p className='w-750'> <b> I do hereby give authorization for disclosure of health information to the agency indicated on this form and for the client, purpose, and specific records indicated on this form. </b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-550'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'> Client/Legal Guardian Signature </td>
                        <td className='small w-200'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-550'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'> Witness (RHCA Staff/Representative) Processing By: Sabrina Betts, Director of Clinical Services & Compliance
                            (MSW CPRP ICADC CADC, CDCA, CFTP, CDBT, CCATP, CTMH, SAP)
                        </td>
                        <td className='small w-200'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}























